<script setup lang="ts">
import { type Component } from 'vue'

const props = defineProps<{
  variant?: 'destructive' | 'warning' | 'info'
  icon: Component
  message: string
}>()

const variantClasses = {
  destructive: 'bg-red-50 dark:bg-red-500/10 border-red-100 dark:border-red-500/20 text-red-600 dark:text-red-400',
  warning: 'bg-amber-50 dark:bg-amber-500/10 border-amber-100 dark:border-amber-500/20 text-amber-600 dark:text-amber-400',
  info: 'bg-indigo-50 dark:bg-indigo-500/10 border-indigo-100 dark:border-indigo-500/20 text-indigo-600 dark:text-indigo-400'
}

const iconContainerClasses = {
  destructive: 'bg-red-100 dark:bg-red-500/20',
  warning: 'bg-amber-100 dark:bg-amber-500/20',
  info: 'bg-indigo-100 dark:bg-indigo-500/20'
}
</script>

<template>
  <div class="flex-1 flex flex-col p-6 min-h-0">
    <div :class="[
      'mt-2 rounded-2xl border p-6 flex flex-col items-center text-center gap-4 transition-colors duration-300',
      variantClasses[props.variant || 'destructive']
    ]">
      <div :class="[
        'h-12 w-12 rounded-full flex items-center justify-center',
        iconContainerClasses[props.variant || 'destructive']
      ]">
        <component :is="props.icon" class="h-6 w-6" />
      </div>
      <p class="text-gray-700 dark:text-gray-300 text-sm font-medium leading-relaxed">
        {{ props.message }}
      </p>
    </div>
  </div>
</template>
